import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MISSION_TYPES, missionLabel } from "@/lib/labels";
import DeliverableStudio from "@/components/app/DeliverableStudio";

function ProgramFormFields(form, setForm, clients) {
  return (
    <>
      <div>
        <Label>Type de mission *</Label>
        <Select value={form.mission_type} onValueChange={(v) => setForm({ ...form, mission_type: v })}>
          <SelectTrigger data-testid="program-type"><SelectValue /></SelectTrigger>
          <SelectContent>{MISSION_TYPES.map((m) => (<SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div>
        <Label>Client (facultatif)</Label>
        <Select value={form.client_id || "none"} onValueChange={(v) => setForm({ ...form, client_id: v === "none" ? "" : v })}>
          <SelectTrigger><SelectValue placeholder="Aucun (programme générique)" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Aucun (générique)</SelectItem>
            {clients.map((c) => (<SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Contexte spécifique</Label>
        <Textarea rows={3} value={form.specific_context} onChange={(e) => setForm({ ...form, specific_context: e.target.value })} />
      </div>
    </>
  );
}

const INITIAL_FORM = { client_id: "", mission_type: "commissariat_comptes", specific_context: "" };

export default function WorkPrograms() {
  return (
    <DeliverableStudio
      kind="programme_travail"
      generateEndpoint="/work-programs/generate"
      eyebrow="Livrables IA"
      title="Programmes de travail"
      description="Diligences, contrôles clés et livrables — générés par type de mission."
      dialogTitle="Nouveau programme de travail"
      generateButtonLabel="Générer un programme"
      generateTestid="generate-program-btn"
      initialForm={INITIAL_FORM}
      renderFormFields={ProgramFormFields}
      buildPayload={(form) => ({
        mission_type: form.mission_type,
        client_id: form.client_id || null,
        specific_context: form.specific_context || null,
      })}
      canSubmit={() => true}
      historyTitleFn={(it) => missionLabel(it.mission_type)}
      historySubtitleFn={(it, clientMap) => clientMap[it.client_id]?.name || "Programme générique"}
      detailTitleFn={(s) => missionLabel(s.mission_type)}
      detailEyebrow="Programme de travail"
      emptyText="Aucun programme pour l'instant."
      emptyHint="Sélectionnez ou générez un programme de travail."
      testidPrefix="program"
    />
  );
}
